import styled, { css } from 'styled-components';

import { calculateFontSize, defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledFlexContainer = styled.div<{ height?: number; width?: number }>(
  ({ height, theme, width }) => {
    return css`
      border: calc(0.5 * ${theme.base.spacing}) solid ${theme.base.colors.black};
      background-color: ${theme.base.colors.blue.light};

      ${height &&
      css`
        height: ${height}rem;
      `}

      ${width &&
      css`
        width: ${width}rem;
      `}
    `;
  }
);

StyledFlexContainer.defaultProps = defaultThemeProp;

export const StyledFlexItem = styled.div<{
  inActive?: boolean;
  noPadding?: boolean;
  width?: number;
}>(({ inActive, noPadding, theme, width }) => {
  const fontSize = calculateFontSize(theme.base['font-size'], theme.base['font-scale']);

  return css`
    border: calc(0.5 * ${theme.base.spacing}) solid ${theme.base.colors.black};
    padding: ${noPadding ? '0' : `calc(4 * ${theme.base.spacing}) `};
    text-align: center;
    background-color: ${inActive ? theme.base.colors.white : theme.base.colors.orange.light};
    color: ${theme.base.colors.black};

    ${width &&
    css`
      width: ${width}rem;
    `}

    span {
      font-size: ${fontSize.xl};
      font-weight: ${theme.base['font-weight'].bold};
    }
  `;
});

StyledFlexItem.defaultProps = defaultThemeProp;
